import { isEmpty, isPlainObject } from './functions'



export function mergeIfEmptyIn(obj, ...data) {
  data.forEach(datum => {
    isPlainObject(datum) && Object.keys(datum).forEach(key => {
      if (isEmpty(obj[key])) {
        obj[key] = datum[key];
      }
    });
  });
  return obj
}

export function mergeIfEmpty(obj, ...data) {
  return mergeIfEmptyIn(Object.assign({}, obj), ...data);
}

export function mergeIfUndefinedIn (obj, ...data) {
  data.forEach(datum => {
    isPlainObject(datum) && Object.keys(datum).forEach(key => {
      if (!(key in obj)) {
        obj[key] = datum[key];
      }
    });
  });
  return obj
}

export function mergeIfUndefined (obj, ...data) {
  return mergeIfUndefinedIn(Object.assign({}, obj), ...data);
}
